// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exercise-page {
  padding: 20px;
  color: black;
  text-align: center;
}

.page-header {
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
}

.exercise-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.search-container3 {
  position: relative;
  display: inline-block;
  width: 300px;
}

.search-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #777;
}

.exercise-search {
  width: 100%;
  padding: 10px 15px 10px 40px;
  font-size: 1rem;
  border-radius: 20px;
  border: 1px solid #ccc;
  background-color: #f8f8f8;
  outline: none;
}

.favorites-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 15px;
  background-color: #f8f8f8;
  border: 1px solid #ccc;
  border-radius: 20px;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.favorites-toggle:hover {
  background-color: #eee;
}

.favorites-toggle.active {
  background-color: #FFD700;
  border-color: #FFD700;
}

.favorites-toggle svg {
  color: #777;
}

.favorites-toggle.active svg {
  color: #000;
}

.exercise-videos-container {
  display: flex;
  justify-content: center;
}

.exercise-videos-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  max-width: 1300px;
}

.video-card {
  background-color: #A5D6A7;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 300px;
  height: 280px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.thumbnail-container {
  height: 200px;
  overflow: hidden;
  position: relative;
}

.thumbnail {
  width: 100%;
  height: 130%;
  object-fit: cover;
}

.favorite-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.favorite-button:hover {
  background: rgba(255, 255, 255, 1);
}

.favorite-button.favorited svg {
  color: #FFD700;
}

.card-footer {
  padding: 15px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.video-title {
  font-weight: bold;
  margin-bottom: 15px;
  color: black;
  font-size: 1.1rem;
}

.button-container {
  margin-top: auto;
  display: flex;
  justify-content: center;
}

.watch-button {
  display: inline-block;
  padding: 8px 20px;
  background-color: #388E3C;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  font-weight: 500;
  transition: background-color 0.3s;
}

.watch-button:hover {
  background-color: #2E7D32;
}

.no-results {
  grid-column: 1 / -1;
  padding: 20px;
  color: black;
}

.loading-message {
  padding: 40px;
  font-size: 1.2rem;
  color: #555;
}

@media (max-width: 1300px) {
  .exercise-videos-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 1000px) {
  .exercise-videos-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .exercise-videos-grid {
    grid-template-columns: 1fr;
  }
  
  .header-controls {
    flex-direction: column;
    gap: 10px;
  }
  
  .search-container3 {
    width: 100%;
  }
}

.exercise-description {
  color: #555;
  font-size: 0.9rem;
  margin: 8px 0;
  padding: 0 10px;
  line-height: 1.4;
  min-height: 10px; 
}

@media (max-width: 700px) {
  .exercise-videos-grid {
    grid-template-columns: 1fr;
  }

  .header-controls {
    flex-direction: column;
    gap: 10px;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .search-container3 {
    width: 90%;
    max-width: 300px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/ExercisePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,uBAAuB;EACzB;AACF","sourcesContent":[".exercise-page {\n  padding: 20px;\n  color: black;\n  text-align: center;\n}\n\n.page-header {\n  margin-bottom: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n}\n\n.header-controls {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.exercise-title {\n  font-size: 32px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.search-container3 {\n  position: relative;\n  display: inline-block;\n  width: 300px;\n}\n\n.search-icon {\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #777;\n}\n\n.exercise-search {\n  width: 100%;\n  padding: 10px 15px 10px 40px;\n  font-size: 1rem;\n  border-radius: 20px;\n  border: 1px solid #ccc;\n  background-color: #f8f8f8;\n  outline: none;\n}\n\n.favorites-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 15px;\n  background-color: #f8f8f8;\n  border: 1px solid #ccc;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.favorites-toggle:hover {\n  background-color: #eee;\n}\n\n.favorites-toggle.active {\n  background-color: #FFD700;\n  border-color: #FFD700;\n}\n\n.favorites-toggle svg {\n  color: #777;\n}\n\n.favorites-toggle.active svg {\n  color: #000;\n}\n\n.exercise-videos-container {\n  display: flex;\n  justify-content: center;\n}\n\n.exercise-videos-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  max-width: 1300px;\n}\n\n.video-card {\n  background-color: #A5D6A7;\n  border-radius: 15px;\n  overflow: hidden;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  width: 300px;\n  height: 280px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.thumbnail-container {\n  height: 200px;\n  overflow: hidden;\n  position: relative;\n}\n\n.thumbnail {\n  width: 100%;\n  height: 130%;\n  object-fit: cover;\n}\n\n.favorite-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: rgba(255, 255, 255, 0.8);\n  border: none;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.favorite-button:hover {\n  background: rgba(255, 255, 255, 1);\n}\n\n.favorite-button.favorited svg {\n  color: #FFD700;\n}\n\n.card-footer {\n  padding: 15px;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.video-title {\n  font-weight: bold;\n  margin-bottom: 15px;\n  color: black;\n  font-size: 1.1rem;\n}\n\n.button-container {\n  margin-top: auto;\n  display: flex;\n  justify-content: center;\n}\n\n.watch-button {\n  display: inline-block;\n  padding: 8px 20px;\n  background-color: #388E3C;\n  color: white;\n  text-decoration: none;\n  border-radius: 5px;\n  font-weight: 500;\n  transition: background-color 0.3s;\n}\n\n.watch-button:hover {\n  background-color: #2E7D32;\n}\n\n.no-results {\n  grid-column: 1 / -1;\n  padding: 20px;\n  color: black;\n}\n\n.loading-message {\n  padding: 40px;\n  font-size: 1.2rem;\n  color: #555;\n}\n\n@media (max-width: 1300px) {\n  .exercise-videos-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 1000px) {\n  .exercise-videos-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 700px) {\n  .exercise-videos-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .header-controls {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .search-container3 {\n    width: 100%;\n  }\n}\n\n.exercise-description {\n  color: #555;\n  font-size: 0.9rem;\n  margin: 8px 0;\n  padding: 0 10px;\n  line-height: 1.4;\n  min-height: 10px; \n}\n\n@media (max-width: 700px) {\n  .exercise-videos-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .header-controls {\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .search-container3 {\n    width: 90%;\n    max-width: 300px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
